import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocMaintenanceRoute } from '@jira/router-routes__eoc-maintenance-routes/src/eocMaintenanceRoute.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { resources as maintenanceResources } from '@atlassian/eoc-maintenance/resources';
import type { Route } from '@atlassian/react-resource-router';
import { LazyMaintenance, MaintenanceComponent } from './ui/MaintenanceComponent.tsx';

export const eocMaintenanceRouteEntry: Route = createEntry(eocMaintenanceRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: MaintenanceComponent,
	layout: opsTeamLayout,

	resources: [
		...getNavigationResources(),
		...maintenanceResources(),
		...teamDashboardResources(),
		getConsolidationStateResource(),
	],

	navigation: {
		menuId: MenuIdPeople,
		horizontal: AsyncHorizontalOperationsNav,
	},

	forPaint: [
		LazyHorizontalOperationsNav,
		LazyAtlassianNavigation,
		LazyMaintenance,
		LazyTeamDashboardSidebar,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
